import { AppAnimate, AppCard, AppGridContainer, AppInfoView } from "@crema";
import UserCreate from "./userCreate";
import UserHeader from "./userHeader";
import { UserData } from "types/models/master/MasterApp";
const defaultUser: UserData = {
  id: 0,
  contactNo: "",
  CreatedOn: new Date(),
  email: "",
  IsActive: false,
  password: "",
  roleId: 0,
  username: "",
  networkPartners: "", 
  name:"",
  SRCode: "",
  permission: "",
  managerId: 0
};


const UserIndex: React.FC<{}> = () => { 
 

  return (
    <>
      {defaultUser ? (
        <AppAnimate animation="transition.slideUpIn" delay={200}>
          <AppCard>
          <UserHeader user={defaultUser} />
             <AppGridContainer>
              <UserCreate />
            </AppGridContainer>
          </AppCard>
        </AppAnimate>
      ) : null}
      <AppInfoView />
    </>
  );
};

export default UserIndex;
